module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flip-horizontal-8337c1d6e66b3b035b75ae608c63900e.svg";